"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPasswordValidation = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactPasswordChecklist = _interopRequireDefault(require("react-password-checklist"));
var _DmsTokenHook = require("../DmsTokenHook/DmsTokenHook");
var _DmsFetch = require("../DmsFetch/DmsFetch");
var _PasswordRegexDescription = require("../../constants/PasswordRegexDescription");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
async function getLoginSettings() {
  const token = (0, _DmsTokenHook.getToken)();
  const url = "/login_settings";
  const getData = await (0, _DmsFetch.fetchData)(url, "GET", token.access_token);
  return getData.data.data.password_format_pk;
}
const DmsPasswordValidation = _ref => {
  let {
    password,
    confirmPassword,
    length = 8
  } = _ref;
  const [rules, setRules] = (0, _react.useState)([]);
  const updateRules = newRules => {
    if (newRules === _PasswordRegexDescription.PasswordRegexDescription.EVERYTHING) {
      setRules(["match"]);
    } else if (newRules === _PasswordRegexDescription.PasswordRegexDescription.UPPER_LOWER_NUMBER_SYMBOL) {
      setRules(["specialChar", "number", "capital", "lowercase", "match"]);
    } else if (newRules === _PasswordRegexDescription.PasswordRegexDescription.ONLY_ALPHANUMERIC) {
      setRules(["letter", "match"]);
    } else if (newRules === _PasswordRegexDescription.PasswordRegexDescription.MIN_8_CHARACTERS) {
      setRules(["minLength", "match"]);
    } else if (newRules === _PasswordRegexDescription.PasswordRegexDescription.MIN_8_CHARACTERS_ALPHANUMERIC) {
      setRules(["letter", "minLength", "match"]);
    } else if (newRules === _PasswordRegexDescription.PasswordRegexDescription.MIN_8_CHARACTERS_NUMBER_AND_SYMBOL) {
      setRules(["minLength", "specialChar", "number", "match"]);
    } else if (newRules === _PasswordRegexDescription.PasswordRegexDescription.MIN_8_CHARACTERS_WITH_UPPER_LOWER_NUMBER_SYMBOL) {
      setRules(["minLength", "specialChar", "number", "capital", "lowercase", "match"]);
    }
  };
  (0, _react.useEffect)(() => {
    const validate = async () => {
      const newRules = await getLoginSettings();
      updateRules(newRules);
    };
    validate();
  }, []);
  return /*#__PURE__*/_react.default.createElement(_reactPasswordChecklist.default, {
    rules: rules,
    minLength: length,
    value: password,
    valueAgain: confirmPassword
  });
};
exports.DmsPasswordValidation = DmsPasswordValidation;